import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
export type HomepageJobCardBrandingFragment = { __typename?: 'Job', brandingEligibility?: { __typename?: 'BrandingEligibilityForJob', shouldShowBranding?: boolean | null, brandingInformation?: { __typename?: 'BrandingInformation', localizedAssets?: { __typename?: 'BrandingLocalizedAssets', logo?: { __typename?: 'LocalizedImageAsset', url: string } | null, banner?: { __typename?: 'LocalizedImageAsset', url: string } | null } | null } | null, brandingAttribution: Array<{ __typename?: 'BrandingAttribution', sourceType: string }> } | null };

export const HomepageJobCardBrandingFragmentDoc = gql`
    fragment homepageJobCardBranding on Job {
  brandingEligibility(input: {requestSource: HOMEPAGE}) @include(if: $shouldQueryBrandingEligibility) {
    shouldShowBranding
    brandingInformation {
      localizedAssets {
        logo {
          url
        }
        banner {
          url
        }
      }
    }
    brandingAttribution {
      sourceType
    }
  }
}
    `;